export default {
  title: '認証ポータル',
  alert_msg:'有効期限が迫っていますのでご注意ください。'
}